import { isNil } from 'lodash-es';
import * as React from 'react';
import { useSearchParams } from 'react-router';

type StepperArgs = {
  initialValue?: number;
  skip?: number;
};
export const usePolicyFormStepper = <Step extends number>({
  initialValue = 0,
  skip,
}: StepperArgs) => {
  const [searchParams] = useSearchParams();
  const [step, setActiveStep] = React.useState<Step>(
    Number(searchParams.get('step') || initialValue) as Step,
  );

  const handlers = React.useMemo(
    () => ({
      set: (target: Step) => setActiveStep(target),
      onNext: () => {
        setActiveStep((prev) => {
          const nextValue = prev + 1;
          return (
            isNil(skip) || nextValue !== skip ? nextValue : nextValue + 1
          ) as Step;
        });
      },
      onPrevious: () => {
        setActiveStep((prev) => {
          const nextValue = prev - 1;
          return (
            isNil(skip) || nextValue !== skip ? nextValue : nextValue - 1
          ) as Step;
        });
      },
    }),
    [skip],
  );

  return [step, handlers] as const;
};
